import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { useMeasure } from 'react-use';
import { DRAWER_HEIGHT_CSS_VAR, DrawerContainer, DrawerContent, DrawerHeader, IconClose, PageSlider } from '@noths/polaris-client-ribbons-design-system';
import { ICON_BUTTON_TEXT_CLASS, iconButton } from '@noths/polaris-client-styles';
import { FooterAppPromo } from "../../FooterAppPromo/FooterAppPromo";
import { NavigationDrilldownList } from "./NavigationDrilldownList";
import * as styles from "../styles/NavigationDrilldown.styles";
import { LocalePanel } from "../../LocalePanel/LocalePanel";
import { useNavigation } from "../hooks/useNavigation/useNavigation";
import { useTracking } from "../hooks/useTracking/useTracking";
export var NavigationDrilldownDrawer = function NavigationDrilldownDrawer(_ref) {
  var navigation = _ref.navigation,
    onClose = _ref.onClose;
  var _useNavigation = useNavigation(navigation),
    onBack = _useNavigation.onBack,
    onSelect = _useNavigation.onSelect,
    _useNavigation$state = _useNavigation.state,
    currentPage = _useNavigation$state.currentPage,
    pages = _useNavigation$state.pages;
  var tracking = useTracking();
  var _useMeasure = useMeasure(),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    drawerHeaderRef = _useMeasure2[0],
    drawerHeaderRect = _useMeasure2[1];
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    expandedState = _useState2[0],
    setExpandedState = _useState2[1];
  var setExpandedIndex = function setExpandedIndex(index) {
    var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    setExpandedState(function (prev) {
      var newState = _objectSpread(_objectSpread({}, prev), {}, {
        [level]: index
      });
      return newState;
    });
  };
  var getExpandedIndex = function getExpandedIndex() {
    var level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return expandedState[level] || null;
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    style: {
      [DRAWER_HEIGHT_CSS_VAR]: "calc(".concat(window.innerHeight, "px - ").concat(drawerHeaderRect.height, "px)")
    },
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    ref: drawerHeaderRef,
    $_css2: styles.headerPageSliderWrapper
  }, /*#__PURE__*/React.createElement(PageSlider, {
    pageIndex: currentPage,
    transition: styles.headerPageSliderTransition
  }, pages.map(function (page) {
    return /*#__PURE__*/React.createElement(DrawerHeader, {
      index: page.index,
      key: page.title,
      onBack: page.index !== 0 ? function () {
        onBack();
        setExpandedState({});
        tracking.onBack(page.index - 1);
      } : undefined,
      title: page.title
    });
  }))), /*#__PURE__*/React.createElement(PageSlider, {
    pageIndex: currentPage,
    transition: styles.contentPageSliderTransition
  }, pages.map(function (page) {
    var disabled = page.index !== currentPage;
    var firstPage = page.index === 0;
    return /*#__PURE__*/React.createElement(DrawerContainer, {
      key: page.title
    }, !page.isEmpty && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DrawerContent, null, /*#__PURE__*/React.createElement(NavigationDrilldownList, {
      disabled: disabled,
      expandedIndex: getExpandedIndex(1),
      getExpandedIndex: getExpandedIndex,
      items: page.items || [],
      level: 0,
      onSelect: onSelect,
      setExpandedIndex: setExpandedIndex
    }), firstPage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_StyledDiv3, {
      $_css3: styles.appPanel
    }, /*#__PURE__*/React.createElement(FooterAppPromo, null)), /*#__PURE__*/React.createElement(_StyledDiv4, {
      $_css4: styles.localePanel
    }, /*#__PURE__*/React.createElement(LocalePanel, {
      placement: "navigation"
    }))))));
  })), /*#__PURE__*/React.createElement(_StyledButton, {
    onClick: onClose,
    $_css5: [iconButton, styles.closeBtn]
  }, /*#__PURE__*/React.createElement(IconClose, {
    height: 24,
    width: 24
  }), /*#__PURE__*/React.createElement("span", {
    className: ICON_BUTTON_TEXT_CLASS
  }, "Close")));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv3 = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv4 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledButton = /*#__PURE__*/_styled5("button").withConfig({
  displayName: "NavigationDrilldownDrawer___StyledButton",
  componentId: "sc-1u44r8u-0"
})(["", ""], function (p) {
  return p.$_css5;
});